// import * as types from "../types";
// const state = {
//   drawer: true
// };
// const getters = {
//   [types.GET_DRAWER]: state => {
//     return state.drawer;
//   }
// };
//
// const mutations = {
//   [types.MUTATE_DRAWER]: state => {
//     state.drawer = !state.drawer;
//   }
// };
//
// const actions = {
//   [types.ACTION_DRAWER]: ({ commit }) => {
//     commit(types.MUTATE_DRAWER);
//   }
// };
//
// export default {
//   state,
//   getters,
//   mutations,
//   actions
// };

export default {
  namespaced: true,
  state: {
    drawer: true
  },
  getters: {
    GET_DRAWER(state) {
      return state.drawer;
    }
  },
  mutations: {
    MUTATE_DRAWER(state, payload) {
      state.drawer = payload;
    }
  },
  actions: {
    ACTION_DRAWER({ commit }, payload) {
      commit("MUTATE_DRAWER", payload);
    }
  }
};
